import type { TreeNodeOptions } from "./types";


export const DefaultTreeOptions:TreeNodeOptions={
    childrenKey:'children',
    idKey:'id',
    path:undefined
}